import React from 'react'
import LargeSidebarLayout from '@/layouts/app/LargeSidebarLayout'

/**
 * AppShell
 *
 * The authenticated app shell: LargeSidebarLayout (sidebar + topnav + outlet).
 * Global infrastructure (offline detection, Echo, hardware) is provided ONCE
 * by SystemInfrastructureProvider in App.tsx — do not nest a second one here.
 *
 * Replaces the legacy Vue `views/app/index.vue` which dynamically swapped
 * layouts via `configStore.getThemeMode.layout` — we standardize on
 * LargeSidebarLayout for the React build.
 */
export const AppShell: React.FC = () => {
  // LargeSidebarLayout is a static import, so this boundary could never suspend
  // — it was dead code. The route-level lazy views are already wrapped by the
  // boundary in App.tsx.
  return <LargeSidebarLayout />
}

export default AppShell
